import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Ri24HoursLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const JustCall = () => {
  return (
    <>
      <div className="justCallSec sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="callCard">
                <div className="icon">
                  <Ri24HoursLine />
                </div>
                <div className="text">
                  <h4>Just call to our call-center</h4>
                  <p>+966565722871</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="callCardDesc">
                <p>
                  We deliver a comprehensive range of solutions designed to enhance and streamline aircraft maintenance operations.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="callCardBtn">
                <Link to="/" className="commonBtn">
                  read more <BsArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JustCall;
